export const trackVKPurchaseGoal = (goalName: string) => {
  if (typeof window !== 'undefined' && window.VK) {
    window.VK.Goal(goalName)
  }
}
